<template>
  <div v-if="seaTour != null">
    <v-app>
    <div class="dashboard-main-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <form id="seaTourForm">
              <div class="form-box">
                <div class="form-content pb-2">
                  <h3 class="title mb-3">Tur</h3>
                  <div class="row justify-content-between">
                    <div class="col-lg-6">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <base-edit-input
                              v-model="seaTour.name"
                              :rules="'required'"
                              :type="'text'"
                              :label="'Adı'">
                          </base-edit-input>
                          <base-edit-input
                              v-model="seaTour.tourCode"
                              :rules="'required'"
                              :type="'text'"
                              :label="'Kod'">
                          </base-edit-input>
                          <base-edit-input
                              v-model="seaTour.nights"
                              :rules="'required|min_value:1'"
                              :type="'number'"
                              :label="'Gece'">
                          </base-edit-input>
                          <div class="input-box">
                            <label class="label-text">Visa</label>
                            <div class="form-group">
                              <input class="form-control" v-model="seaTour.visaRequired" type="checkbox" placeholder="">
                            </div>
                          </div>
                          <div class="input-box">
                            <label class="label-text">Web'te aktif</label>
                            <div class="form-group">
                              <input class="form-control" v-model="seaTour.webVisibility" type="checkbox" placeholder="">
                            </div>
                          </div>
<!--                          <sea-tour-ports></sea-tour-ports>-->
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <div class="input-box">
                            <label class="label-text">Resim</label>
                            <base-image-edit-input
                                v-model="seaTour.imageUrl"
                                :rules="'required'">
                            </base-image-edit-input>
                          </div>
                        </div>
                      </div>
                      <div class="card-item p-3" v-if="panelRights['PANEL_SEATOUR_DETAIL_SHARED_AVAILABILITY']">
                        <v-data-table
                            :headers="headers"
                            :items="sharedSeaTourList"
                            :items-per-page="5"
                            class="elevation-1">
                          <template v-slot:top>
                            <v-toolbar
                                flat>
                              <v-toolbar-title>Kontenjan Paylaşımı</v-toolbar-title>
                              <v-divider
                                  class="mx-4"
                                  inset
                                  vertical
                              ></v-divider>
                              <v-spacer></v-spacer>
                              <v-dialog
                                  v-model="dialog"
                                  max-width="500px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      color="primary"
                                      dark
                                      class="mb-2"
                                      v-bind="attrs"
                                      v-on="on"
                                  @click="onOpenCreateSharedSeaTourModal">
                                    <i class="la la-plus mr-1"></i>
                                    Yeni Kontenjan Paylaşımı Yarat
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                  </v-card-title>

                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col
                                            cols="12"
                                            sm="6"
                                            md="4">
                                          <div style="width: 300px">
                                          <base-select-input
                                              v-model="editedItem.seaTourId"
                                              :optionList="seaTourList"
                                              :rules="'required'"
                                              :label="'Tur'"
                                              :href="basePath+'/seatours/'+editedItem.seaTourId"
                                              :href-text="editedItem.seaTourId">
                                          </base-select-input>
                                          </div>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        v-if="editedIndex <= -1"
                                        color="blue darken-1"
                                        text
                                        @click="close">
                                      Cancel
                                    </v-btn>
                                    <v-btn
                                        v-if="editedIndex <= -1"
                                        color="blue darken-1"
                                        text
                                        @click="save">
                                      Save
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-toolbar>
                          </template>
                          <template v-slot:item.seaTourId="{ item }">
                            <tr>
                              {{ seaTourMap ? seaTourMap[item.seaTourId].name : "--" }}
                            </tr>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <div class="row">
                              <div class="table-content mr-2" v-on:click="deleteItem(item)">
                                <div class="theme-btn theme-btn-small">
                                  <i class="la la-trash"></i>
                                </div>
                              </div>
                              <div class="table-content" @click="editItem(item)">
                                <div class="theme-btn theme-btn-small">
                                  <i class="la la-edit"></i>
                                </div>
                              </div>
                            </div>
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                    <sea-tour-routes v-if="seaTour.id !== -1"></sea-tour-routes>
                    <div class="btn-box">
                      <button v-if="seaTour.id === -1" :class="{'disabled' : !formValid}" @click="create" class="theme-btn" type="button">Kaydet</button>
                      <button v-else :class="{'disabled' : !formValid}" @click="update" class="theme-btn" type="button">Güncelle</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </v-app>
  </div>
</template>

<script>
import UploadImage from "../common/UploadImage";
import BaseEditInput from "../base/BaseEditInput";
import BaseImageEditInput from "../base/BaseImageEditInput";
import validationFormUtils from "../../util/validationFormUtils";
import SeaTourRoutes from "./SeaTourRoutes";
import messagePopupManager from "../../util/messagePopupManager";
import BaseSelectInput from "../base/BaseSelectInput";


export default {
  name: "SeaTourDetail",
  data:function (){
    return{
      formValid:false,
      dialog: false,
      editedItem: {
        seaTourId: 0,
      },
      defaultItem: {
        seaTourId: 0,
      },
      editedIndex: -1,
      headers: [
        {
          text: 'Tur Adı',
          align: 'start',
          sortable: true,
          value: 'seaTourId',
        },
        {
          text: '-',
          value: 'actions',
        }
      ],
      sharedSeaTourList:[]
      // items: [{
      //   seaTourId:67
      // }]
    }
  },
  components: {BaseSelectInput, SeaTourRoutes, BaseImageEditInput, BaseEditInput, UploadImage },
  computed:{
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    seaTour:{
      get(){
        return this.$store.getters.getSeaTour;
      }
    },
    portList:{
      get(){
        return this.$store.getters.getPortList
      }
    },
    seaTourList:{
      get(){
        return this.$store.getters.getSeaTourList;
      }
    },
    seaTourMap:{
      get(){
        if(!this.$store.getters.getSeaTourList) return null;
        return this.$store.getters.getSeaTourList.reduce(function (map, seaTour) {
          map[seaTour.id] = seaTour;
          return map;
        }, {});
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      $('.select-contain-select').selectpicker('refresh')
    });
  },
  methods:{
    create(){
      if(this.formValid) {
        this.removeEmptyPorts();
        this.seaTour.sharedSeaTourIds = [];
        this.sharedSeaTourList.forEach(sharedSeaTour => {
          this.seaTour.sharedSeaTourIds.push(sharedSeaTour.seaTourId);
        })
        this.$store.dispatch("saveSeaTour", this.seaTour)
        .then(response => {
          messagePopupManager.showSuccess();
        })
        // this.$store.dispatch("batchUpdateSeaTourRoute")
      }
    },
    update(){
      if(this.formValid) {
        this.removeEmptyPorts();
        this.seaTour.sharedSeaTourIds = [];
        this.sharedSeaTourList.forEach(sharedSeaTour => {
          this.seaTour.sharedSeaTourIds.push(sharedSeaTour.seaTourId);
        })
        this.$store.dispatch("updateSeaTour", this.seaTour).then(()=>{
          this.$store.dispatch("batchUpdateSeaTourRoute")
        })

      }
    },
    removeEmptyPorts(){
      this.seaTour.ports = this.seaTour.ports.filter((port)=>{
        return port !== 0;
      });
    },
    editItem (item) {
      this.editedIndex = this.sharedSeaTourList.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      this.editedItem = item;
      this.dialog = true
    },
    onOpenCreateSharedSeaTourModal(){
      this.editedIndex = -1;
    },
    deleteItem (item) {
      messagePopupManager.showDeleteQuestion(() => {
        this.sharedSeaTourList.splice(this.sharedSeaTourList.indexOf(item),1);
      })
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save () {
      if (this.editedIndex > -1) {
        // this.sharedSeaTourList[this.editedIndex] = Object.assign({}, this.editedItem)
        // this.$store.dispatch("updateMarket", this.editedItem)
        //     .catch(error => {
        //       messagePopupManager.showError();
        //     })
      } else {
        this.sharedSeaTourList.push(Object.assign({}, this.editedItem));
        // this.$store.dispatch("createMarket", this.editedItem)
        //     .catch(error => {
        //       messagePopupManager.showError();
        //     })
      }
      this.close()
    }
  },
  watch:{
    seaTour:{
      deep:true,
      handler:function (){
        validationFormUtils.checkFormFields(this);
      }
    }
  },
  mounted() {
    this.$store.dispatch("loadSeaTourList").then(value => {
      this.sharedSeaTourList.splice(0);

      if(this.seaTour.sharedSeaTourIds) {
        for (let i = 0; i < this.seaTour.sharedSeaTourIds.length; i++) {
          let sharedSeaTourId = this.seaTour.sharedSeaTourIds[i];

          this.sharedSeaTourList.push({
            seaTourId: sharedSeaTourId
          })
        }
      }
    });
  }
}
</script>

<style scoped>

</style>